var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.13947 1.71743C8.80532 0.029141 11.1947 0.0291411 11.8605 1.71743L13.3583 5.51499C13.5616 6.03044 13.9696 6.43845 14.485 6.64174L18.2826 8.13947C19.9709 8.80532 19.9709 11.1947 18.2826 11.8605L14.485 13.3583C13.9696 13.5616 13.5616 13.9696 13.3583 14.485L11.8605 18.2826C11.1947 19.9709 8.80532 19.9709 8.13947 18.2826L6.64174 14.485C6.43845 13.9696 6.03044 13.5616 5.51499 13.3583L1.71743 11.8605C0.0291411 11.1947 0.029141 8.80532 1.71743 8.13947L5.51499 6.64174C6.03044 6.43845 6.43845 6.03044 6.64174 5.51499L8.13947 1.71743Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.13947 1.71743C8.80532 0.029141 11.1947 0.0291411 11.8605 1.71743L13.3583 5.51499C13.5616 6.03044 13.9696 6.43845 14.485 6.64174L18.2826 8.13947C19.9709 8.80532 19.9709 11.1947 18.2826 11.8605L14.485 13.3583C13.9696 13.5616 13.5616 13.9696 13.3583 14.485L11.8605 18.2826C11.1947 19.9709 8.80532 19.9709 8.13947 18.2826L6.64174 14.485C6.43845 13.9696 6.03044 13.5616 5.51499 13.3583L1.71743 11.8605C0.0291411 11.1947 0.029141 8.80532 1.71743 8.13947L5.51499 6.64174C6.03044 6.43845 6.43845 6.03044 6.64174 5.51499L8.13947 1.71743Z",
    fill: "#333333",
    fillOpacity: 0.8
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.1b704496.svg";
export { ForwardRef as ReactComponent };